import dynamic from 'next/dynamic';

const AgeCheckModalConfirmDynamic = dynamic(
  async () => import('./index').then((m) => m.AgeCheckModalConfirm),
  {
    ssr: false,
    loading: () => null,
  }
);

export { AgeCheckModalConfirmDynamic };
